import themeGB from './GB'
import themeBOT from './BOT'
import themeQDB from './QDB'

export const GB = themeGB
export const BOT = themeBOT
export const QDB = themeQDB
